<template>
  <div class="container-fluid">
    <div class="col-xl-12 col-lg-12 col-md-12">
      <div class="page-content__header-description" style="display: flex; margin-bottom: 20px;">
        <h2 style="flex: 1;">Alarms</h2>
      </div>
      <div class="container-fluid">
        <el-tabs v-model="activeTab">
          <can I="create" a="installation">
            <el-tab-pane label="Alarm Config" name="alarm_config">
                <div class="main-container">
                    <vk-offcanvas flipped overlay stuck :show.sync="showOffCanvas">
                        <div>
                          <!-- {{installationList}} -->
                            <vk-offcanvas-close @click="showOffCanvas = false"></vk-offcanvas-close>
                            <h3>New Alarm Configuration</h3>
                            <hr />
                        </div>
                        <el-form class="form" ref="form" :model="form" label-width="150px" label-position="left">
                            <el-form-item class="form-item" label="Label">
                                <el-input
                                v-model="form.label"
                                ></el-input>
                            </el-form-item>
                            <el-form-item class="form-item" label="Field Name">
                                <el-input
                                v-model="form.fieldName"
                                ></el-input>
                            </el-form-item>
                            <el-form-item class="form-item" label="Field Property">
                                <el-input
                                v-model="form.fieldProperty"
                                ></el-input>
                            </el-form-item>
                            <el-form-item class="form-item" label="Condition">
                                <el-switch
                                v-model="form.condition"
                                active-text="Greater than"
                                inactive-text="Less than"
                                active-value="Greater than"
                                inactive-value="Less than">
                                </el-switch>
                            </el-form-item>
                            <el-form-item class="form-item" label="Value">
                                <el-input
                                v-model="form.value"
                                ></el-input>
                            </el-form-item>
                            <el-form-item class="form-item" label="Installation">
                            <el-select
                              v-model="form.installationId"
                              filterable
                              placeholder="Installation"
                              style="width: 100%;"
                            >
                              <el-option
                                v-for="(item, idx ) in installationList"
                                :key="`${idx}_installation_option${item.name}`"
                                :label="item.name"
                                :value="item.id"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                            <el-button type="primary" style="margin-left:45%" @click="createAlarm">Create</el-button>
                        </el-form>
                    </vk-offcanvas>
                    <div style="width: 100%;">
                        <div
                            class="custom-table-row"
                            style="display: flex; flex-flow: row; justify-content: space-between;"
                        >
                            <el-input
                            style="max-width: 200px"
                            placeholder="Type something"
                            prefix-icon="el-icon-search"
                            v-model="searchTerm"
                            ></el-input>
                            <can I="create" a="installation">
                                <span style="display: flex; align-items: center;">
                                    <button class="btn btn-primary" @click="showOffCanvas = true">New Alarm</button>
                                </span>
                            </can>
                        </div>

                        <vue-good-table
                          :lineNumbers="true"
                          :columns="fields"
                          :rows="getUsers"
                          :select-options="selectOption"
                          :search-options="{enabled: true,
                          searchFn: searchTable,
                                  externalQuery: searchTerm}"
                          :pagination-options="{enabled: true}"
                        >
                          <template slot="table-row" slot-scope="props" style="background: red;">
                            <!-- {{props.row}} -->
                            <span v-if="props.column.field == 'full_name'">{{ props.row.name }}</span>
                            <span v-if="props.column.field == 'cid'">{{ props.row.CID?props.row.CID:'' }}</span>
                            <span v-if="props.column.field == 'devicetype'">{{ props.row.deviceType.name }}</span>
                            <span v-if="props.column.field == 'email'">{{ props.row.user.email }}</span>
                            <span v-if="props.column.field == 'phoneNumber'">{{ props.row.user.phoneNumber }}</span>
                            <span v-if="props.column.field == 'actions'">
                              <b-button-group>
                                <b-button variant="primary" @click.stop="navTo(props.row.id)">View Alarm Config</b-button>
                              </b-button-group>
                            </span>
                          </template>
                          <template slot="pagination-bottom" slot-scope="props">
                            <grey-pagination
                              :total="props.total"
                              :pageChanged="props.pageChanged"
                              :perPageChanged="props.perPageChanged"
                            ></grey-pagination>
                          </template>
                        </vue-good-table>

                        <!-- <vue-good-table
                            :lineNumbers="true"
                            :columns="columns"
                            :rows="alarmData"
                            :pagination-options="{enabled: true}"
                        >
                            <template slot="table-row" slot-scope="props">
                            <span v-if="props.column.field == 'title'">{{ props.row.title? props.row['title']:'--' }}</span>
                            <span
                                v-if="props.column.field == 'endpoint'"
                            >{{ props.row.endpoint? props.row['endpoint']:'--' }}</span>
                            <span v-if="props.column.field == 'actions'" class="fancy">
                                <el-button size="mini" type="danger" plain @click="deleteReport(props.row)">Delete</el-button>
                            </span>
                            </template>
                            <template slot="pagination-bottom" slot-scope="props">
                            <grey-pagination
                                :total="props.total"
                                :pageChanged="props.pageChanged"
                                :perPageChanged="props.perPageChanged"
                            ></grey-pagination>
                            </template>
                        </vue-good-table> -->
                    </div>
              </div>
            </el-tab-pane>
          </can>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Select,
  Button,
  Autocomplete,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  RadioButton,
  Tag
  // ...
} from "element-ui";

import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
import { Modal, ModalClose, ModalTitle } from "vuikit/lib/modal";
export default {
  name: "alarmConfig",
  components: {
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "vk-modal-title": ModalTitle,
    "vk-modal": Modal,
    "vk-modal-close": ModalClose,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-tag": Tag
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data() {
    return {
        activeTab: "alarm_config",
        searchTerm: "",
        showOffCanvas: false,
        installationList: [],
        getUsers: "",
        selectOption: {
          enabled: true
        },
        fields: [
          {
            field: "full_name",
            label: "Full Name",
            sortable: "true"
          },
          {
            field: "devicetype",
            label: "Device Type",
            sortable: "true"
          },
          {
            field: "cid",
            label: "Customer ID",
            sortable: "true"
          },
          {
            field: "email",
            label: "E-mail",
            sortable: "true"
          },
          {
            field: "phoneNumber",
            label: "Phone Number",
            sortable: "true"
          },
          {
            field: "actions",
            label: "Actions"
          }
        ],
        form: {
            label: null,
            fieldName: null,
            fieldProperty: null,
            condition: "Greater than",
            value: null
        },
    };
  },
  methods:{
    navTo(deviceId) {
      this.$router.push({
        // path: `/device/${deviceId}`,
        name: "viewDevices",
        params: {
          deviceId: deviceId,
          activetab: "alarm"
        }
      });
    },
    searchTable(row, col, cellValue, searchTerm) {
      return (
        Object.values(row)
          .join("<%>")
          .toLowerCase()
          .indexOf(searchTerm.toLowerCase()) > -1
      );
    },
    getInstallations() {
      const HTTP = this.$httpUtils.instance;
      const container = this;
      HTTP.get("/installations").then(installations => {
        container.installationList = installations.data;
      });
    },
    getUserList() {
      const HTTP = this.$httpUtils.instance;
      const container = this;
      HTTP.get(`/installations?filter={"include":["deviceType","alarmConfig","user","operationsEngineer"]}`).then(installations => {
        container.getUsers = installations.data.filter(x=>x.alarmConfig.length!=0);
      });
    },
    createAlarm(){
        //this.form.condition==true ? this.form.condition="Greater than" : this.form.condition="Less than"
        console.log(this.form);
        const container = this;
        const HTTP = this.$httpUtils.instance;
        const url = "/alarmConfigs";
        HTTP.post(url, this.form)
          .then(response => {
            container.showOffCanvas = false;
            container.getUserList();
            container.showSuccessMsg({
              message: "Alarm Created!"
            });
          })
          .catch(error => {
            container.showErrorMsg({
              message:JSON.stringify(error.response.data.error.details.messages)
            });
          });
    },
  },
  mounted() {
    this.getInstallations();
    this.getUserList();
  }
};
</script> 


// WEBPACK FOOTER //
// src/components/pages/alarm/alarmConfig.vue